module.exports = __webpack_public_path__ + "img/clipboard-v2.b90646fc.svg";